var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2199 12.6944C21.6104 12.3039 21.6104 11.6707 21.2198 11.2802C20.8293 10.8897 20.1962 10.8897 19.8056 11.2802L16.5 14.5858L13.1944 11.2802C12.8039 10.8897 12.1707 10.8897 11.7802 11.2802C11.3897 11.6707 11.3897 12.3039 11.7802 12.6944L15.0858 16L11.7802 19.3057C11.3897 19.6962 11.3897 20.3294 11.7802 20.7199C12.1707 21.1104 12.8039 21.1104 13.1944 20.7199L16.5 17.4143L19.8056 20.7199C20.1962 21.1104 20.8293 21.1104 21.2198 20.7199C21.6104 20.3294 21.6104 19.6962 21.2199 19.3057L17.9142 16L21.2199 12.6944Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d8bf8e35755912f0acf2aa977868e377.svg";
export { ForwardRef as ReactComponent };